import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  Input,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */

const HomePageContainer = () => (
  <div>
    <Responsive {...Responsive.onlyComputer}>
      <HomepageHeading />
    </Responsive>
    <Responsive {...Responsive.onlyTablet}>
      <HomepageHeading mobile={true} />
    </Responsive>
    <Responsive {...Responsive.onlyMobile}>
      <HomepageHeading mobile={true} />
    </Responsive>
  </div>
);

const HomepageHeading = ({ mobile }) => (
  <Container>
    <Grid verticalAlign="middle">
      <Grid.Row columns={2}>
        <Grid.Column computer={10} tablet={16} mobile={16}>
          <Container
            style={{
              padding: mobile ? "3.5em 0" : "7em 0"
            }}
          >
            <Header
              as="h1"
              content="Analytics for measuring your crypto community"
              // inverted
              style={{
                fontSize: mobile ? "3em" : "4em",
                fontWeight: "normal"
                // marginBottom: 0
              }}
            />
            <Header
              as="h2"
              content="PulserDash gives your team insights to understand your community's growth across today’s relevant platforms"
              // inverted
              color="grey"
              style={{
                fontSize: mobile ? "1.5em" : "1.7em",
                fontWeight: "normal",
                marginTop: mobile ? "0.5em" : "1.5em"
              }}
            />
            <Grid>
              <Grid.Row columns={1} centered>
                <Grid.Column>
                  <Input
                    size="huge"
                    // actionPosition="right"
                    placeholder="Enter your email address"
                    fluid
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1} centered>
                <Grid.Column>
                  <Button fluid color="teal" size="huge">
                    Request early access
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Grid.Column>
        <Grid.Column computer={6} tablet={16} mobile={16}>
          <Container
            style={{
              margin: mobile ? "1.0em 0" : "2.0em 0"
            }}
          >
            <Grid centered textAlign="center" verticalAlign="middle">
              <Grid.Row columns={3} centered>
                <Grid.Column textAlign="center">
                  <Icon color="blue" name="telegram" size="huge" />
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <Icon className="discord" color="blue" size="huge" />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2} centered>
                <Grid.Column textAlign="center">
                  <Icon name="line chart" size="huge" color="grey" />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4} centered>
                <Grid.Column textAlign="center">
                  <Icon
                    color="blue"
                    name="twitter square"
                    inverted
                    size="huge"
                  />
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <Icon color="red" name="reddit square" size="huge" />
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <Icon
                    color="grey"
                    name="github square"
                    inverted
                    size="huge"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row textAlign="center" centered>
        <Button basic color="blue" size="huge">
          <Icon className="discord" />
          Join Discord
        </Button>
      </Grid.Row>
    </Grid>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool
};

const HomepageLayout = () => (
  <Responsive>
    <Visibility
      once={false}
      onBottomPassed={this.showFixedMenu}
      onBottomPassedReverse={this.hideFixedMenu}
    >
      <Segment
        // inverted
        textAlign="center"
        style={{ minHeight: 400, padding: "1em 0em" }}
        vertical
      >
        <Container>
          <Header style={{ fontSize: "3em", padding: "0.5em 0" }} color="teal">
            <Icon name="heartbeat" />
            PulserDash
          </Header>
        </Container>
        <HomePageContainer />
      </Segment>
    </Visibility>
  </Responsive>
);

export default HomepageLayout;

// <Segment style={{ padding: "8em 0em" }} vertical>
//       <Container>
//         <Header as="h2" style={{ fontSize: "2.4em" }}>
//           The world's first community management analytics dashboard
//         </Header>
//         <Segment style={{ padding: "8em 0em 0em" }} vertical>
//           <Grid columns={3}>
//             <Grid.Column>
//               <Header as="h2" icon>
//                 <Icon name="dashboard" />
//                 Measure
//                 <Header.Subheader>
//                   Manage your account settings and set e-mail preferences.
//                 </Header.Subheader>
//               </Header>
//             </Grid.Column>
//             <Grid.Column>
//               <Header as="h2" icon>
//                 <Icon name="cogs" />
//                 Learn
//                 <Header.Subheader>
//                   Manage your account settings and set e-mail preferences.
//                 </Header.Subheader>
//               </Header>
//             </Grid.Column>
//             <Grid.Column>
//               <Header as="h2" icon>
//                 <Icon name="line chart" />
//                 Grow
//                 <Header.Subheader>
//                   Manage your account settings and set e-mail preferences.
//                 </Header.Subheader>
//               </Header>
//             </Grid.Column>
//           </Grid>
//         </Segment>
//       </Container>
//     </Segment>
//     <Segment style={{ padding: "8em 0em" }} vertical>
//       <Grid container stackable verticalAlign="middle">
//         <Grid.Row>
//           <Grid.Column width={8}>
//             <Header as="h3" style={{ fontSize: "2em" }}>
//               We Help Companies and Companions
//             </Header>
//             <p style={{ fontSize: "1.33em" }}>
//               We can give your company superpowers to do things that they never
//               thought possible. Let us delight your customers and empower your
//               needs... through pure data analytics.
//             </p>
//             <Header as="h3" style={{ fontSize: "2em" }}>
//               We Make Bananas That Can Dance
//             </Header>
//             <p style={{ fontSize: "1.33em" }}>
//               Yes that's right, you thought it was the stuff of dreams, but even
//               bananas can be bioengineered.
//             </p>
//           </Grid.Column>
//           <Grid.Column floated="right" width={6}>
//             <Image
//               bordered
//               rounded
//               size="large"
//               src="/assets/images/wireframe/white-image.png"
//             />
//           </Grid.Column>
//         </Grid.Row>
//         <Grid.Row>
//           <Grid.Column textAlign="center">
//             <Button size="huge">Check Them Out</Button>
//           </Grid.Column>
//         </Grid.Row>
//       </Grid>
//     </Segment>

//     <Segment style={{ padding: "0em" }} vertical>
//       <Grid celled="internally" columns="equal" stackable>
//         <Grid.Row textAlign="center">
//           <Grid.Column style={{ paddingBottom: "5em", paddingTop: "5em" }}>
//             <Header as="h3" style={{ fontSize: "2em" }}>
//               "What a Company"
//             </Header>
//             <p style={{ fontSize: "1.33em" }}>
//               That is what they all say about us
//             </p>
//           </Grid.Column>
//           <Grid.Column style={{ paddingBottom: "5em", paddingTop: "5em" }}>
//             <Header as="h3" style={{ fontSize: "2em" }}>
//               "I shouldn't have gone with their competitor."
//             </Header>
//             <p style={{ fontSize: "1.33em" }}>
//               <Image avatar src="/assets/images/avatar/large/nan.jpg" />
//               <b>Nan</b> Chief Fun Officer Acme Toys
//             </p>
//           </Grid.Column>
//         </Grid.Row>
//       </Grid>
//     </Segment>

//     <Segment style={{ padding: "8em 0em" }} vertical>
//       <Container text>
//         <Header as="h3" style={{ fontSize: "2em" }}>
//           Breaking The Grid, Grabs Your Attention
//         </Header>
//         <p style={{ fontSize: "1.33em" }}>
//           Instead of focusing on content creation and hard work, we have learned
//           how to master the art of doing nothing by providing massive amounts of
//           whitespace and generic content that can seem massive, monolithic and
//           worth your attention.
//         </p>
//         <Button as="a" size="large">
//           Read More
//         </Button>

//         <Divider
//           as="h4"
//           className="header"
//           horizontal
//           style={{ margin: "3em 0em", textTransform: "uppercase" }}
//         >
//           <a href="#">Case Studies</a>
//         </Divider>

//         <Header as="h3" style={{ fontSize: "2em" }}>
//           Did We Tell You About Our Bananas?
//         </Header>
//         <p style={{ fontSize: "1.33em" }}>
//           Yes I know you probably disregarded the earlier boasts as non-sequitur
//           filler content, but it's really true. It took years of gene splicing
//           and combinatory DNA research, but our bananas can really dance.
//         </p>
//         <Button as="a" size="large">
//           I'm Still Quite Interested
//         </Button>
//       </Container>
//     </Segment>



// WEBPACK FOOTER //
// ./src/Home.jsx